<script>
// Vuex
import { mapGetters } from 'vuex'
import { habeasMethods, captacionMethods } from '@state/helpers'
import {
  BIcon,
  BIconExclamationCircleFill
} from 'bootstrap-vue'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect,
    BIcon,
    BIconExclamationCircleFill
  },
  data() {
    return {
      showAlert: null,
    }
  },
  mounted() {
    this.getCashRegisters()
    this.showAlert = Boolean(this.store && this.cashRegister && this.casherRegister)
  },

  watch: {
    store(val) {
      this.showAlert = Boolean(this.store && this.cashRegister )
    },
    cashRegister(val) {
      this.showAlert = Boolean(this.store && this.cashRegister)
    },
    casherRegister(val) {
      this.showAlert = Boolean(this.store && this.casherRegister )
    },
  },

  computed: {
    ...mapGetters({
      stores: 'captacionPos/stores',
      store: 'captacionPos/store',
      cashRegister: 'captacionPos/cashRegister',
      casherRegister: 'captacionPos/casherRegister',
    }),
  },

  methods: {
    // Cajas POS

    ...captacionMethods,
    getCashRegisters() {
      return this.fetchCashRegisterList()
        .then((response) => {
          this.setStores(response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    deleteCache() {
      localStorage.clear();
      console.log('Delete Cache')
      location.reload();
    },
  },
}
</script>

<template>
  <b-container style="width:100%; height:100%">
    <div style="width:100%; height:100%" class="d-flex align-items-center justify-content-center flex-column">
      <b-button @click="deleteCache"
      v-b-tooltip.hover="{
                variant: 'primary',
                placement: 'leftbottom',
                title: $t('reload'),
              }"
      class="rounded-circle p-0 reload d-flex shadow"
      variant="outline-primary"
      >
        <span class="d-flex mx-auto nva">
          <i style="color: #131a79;" class="fas fa-sync-alt h4 "></i>
        </span>
      </b-button>
      <div
      style="width:100%"
        class="card shadow mt-2" 
        :class="{ 'border-danger': !showAlert }"
      > 
        <div class="card-body p-3 pb-0 pt-2" >
          <b-form id="forms_habeas" @submit.prevent="enviarForm">
            <b-row class="justify-content-center">
              <b-col cols="10">
                <b-form-group>
                  <label class="typo__label">Seleccionar centro operativo</label>
                  <div class="text-center" v-if="!stores.length">
                    <b-spinner variant="primary" label="Spinning"></b-spinner>
                  </div>
                  <div v-if="stores.length">
                    <multiselect
                      :value="store"
                      v-on:select="
                        () => {
                          setCashRegister(null);
                          setCasherRegister(null);
                        }
                      "
                      @input="setStore"
                      :options="stores"
                      :close-on-select="true"
                      :clear-on-select="true"
                      :preserve-search="true"
                      placeholder="Centro Operativo"
                      label="store_name"
                      track-by="store_code"
                      :allowEmpty="false"
                      :showLabels="false"
                      class="h4"
                    >
                    </multiselect>
                    <span v-if="!store" style="color: red">
                      *Seleccione un valor de la lista
                    </span>
                  </div>
                </b-form-group>

                <b-form-group>
                  <div v-if="store">
                    <label class="typo__label">Seleccionar caja</label>
                    <multiselect
                      :value="cashRegister"
                      :options="store.cash_register"
                      @input="setCashRegister"
                      :close-on-select="true"
                      :clear-on-select="true"
                      :preserve-search="true"
                      placeholder="Numero de caja"
                      label="id"
                      track-by="id"
                      :allowEmpty="false"
                      :showLabels="false"
                      class="h4"
                    >
                    </multiselect>
                    <span v-if="!cashRegister || !showAlert" style="color: red">
                      *Seleccione un valor de la lista
                    </span>
                  </div>
                </b-form-group>

                <b-form-group>
                  <div v-if="store">
                    <label class="typo__label">Seleccionar cajero</label>
                    <multiselect
                      :value="casherRegister"
                      :options="store.casher_register"
                      @input="setCasherRegister"
                      :close-on-select="true"
                      :clear-on-select="true"
                      :preserve-search="true"
                      placeholder="Codigo de cajero"
                      label="codcaj"
                      track-by="codcaj"
                      :allowEmpty="false"
                      :showLabels="false"
                      class="h4"
                    >
                    </multiselect>
                    <span v-if="!casherRegister || !showAlert" style="color: red">
                      *Seleccione un valor de la lista
                    </span>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </div>
      </div>
            <div v-if="!showAlert" >
            <h5 class="text-center text-danger pt-0"
              >
              <b-icon icon="exclamation-circle-fill" animation="fade"></b-icon>
              Por favor indique <span v-if="!store"><b>Centro Operativo</b> y </span><b>Caja</b> para continuar</h5
            >
          </div>
    </div>
  </b-container>
</template>
<style lang="scss">
.multiselect__tags {
  min-height: 38px;
  display: block;
  max-height: 30px;
  padding: 6px 40px 0 8px;
  border-radius: 5px;
  border: 1px solid #121a79;
  background: #fff;
  font-size: 14px;
}

.multiselect.h4 { 
  margin-top: 0px;
  margin-bottom: 0px;
  .multiselect__single {
    font-size: 20px;
  }
}
.multiselect__option--selected.multiselect__option--highlight {
  background:#FFEC00 !important;
  color: #fff;
}

.typo__label {
  font-family: "Roboto Condensed",sans-serif;
  font-weight: normal;
}

.multiselect__single {
  background: transparent;
  font-size: 20px;
  margin: 0px;
  margin-top: 4px;
}
 .multiselect__placeholder {
  font-size: 18px;
 }
 .nva:hover i::before {
  color: #ffffff !important;
}
.reload {
  background: rgba(12, 8, 238, 0.144);
  position: absolute;
  z-index: 1;
  right: 90px;
  top: 20px;
  font-size: 35px;
  width: 50px;
  height: 50px;
}
</style>
